const utils = require('../../../lib/utils')

module.exports = {
	model: {
		dataFlag: 'dataTEXT',
		data: null,
		dataFormatted: null,
		keyDownLabel: '',

		config: {}
	},

	events: {
		onChange: {
			type: 'change',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				var self = event.data.component;
				self.updateValue(self.$.find('input').val(), true);
			}
		},
		onKeyUp: {
			type: 'keyup',
			action: function(event){
				var self = event.data.component;
				self.updateKeyDownLabelValue(self.$.find('input').val());
			}
		},
		subTitleFocusForward: {
			type: 'click',
			selector: '.innerTitle',
			action: function(event){
				event.preventDefault()
				event.stopImmediatePropagation()

				const $target = $(event.target).closest('.innerTitle')
				const $input = $target.parent().find('input')

				$input.focus()
			}
		},
		copyToClipboard: {
			type: 'click',
			selector: 'button',
			action: async event => {
				const fieldType = $(event.target).closest('button').data('fieldType')

				if(fieldType === 'copyToClipboard'){
					event.stopImmediatePropagation()

					const self = event.data.component
					const $input = self.$.find('input')
					const value = $input.val()

					const success = await utils.copyToClipboard(value)
					let statusController = getComponent('statusController')
					if(statusController){
						if(success){
							statusController.addPanel('status.done.copyToClipboard');
						} else {
							statusController.addPanel('status.problem.copyToClipboard');
						}
					}
				}
			}
		}
	},

	methods: {
		prepare: function(){
			this.model.disabled = false;
			this.model.isFilterField = false;
			if((this.formMapping || {}).fieldConfig) {
				this.model.disabled        = Boolean(this.formMapping.fieldConfig.disabled);
				this.model.isFilterField   = Boolean(this.formMapping.fieldConfig.isFilterField);
			}


			this.model.config = this.model.config || {};
			this.model.disabled |= this.model.config.disabled;
			if(!this.model.placeholder){
				if(this.model.config.placeholder) 		this.model.placeholder = this.model.config.placeholder;
				if(this.model.config.placeholderKey)	this.model.placeholder = utils.i18next.__(this.model.config.placeholderKey)
			}

			if(this.model.isFilterField) 				this.model.dataFlag = 'filterValue';
			else if(this.model.dataINT !== undefined) 	this.model.dataFlag = 'dataINT';
			else if(this.model.dataFLOAT !== undefined) this.model.dataFlag = 'dataFLOAT';
			else if(this.model.dataTEXT !== undefined) 	this.model.dataFlag = 'dataTEXT';
			else 										this.model.dataFlag = 'data';

			this.updateValue();
		},

		updateValue: function(value, tellParents){
			const fieldConfig = this.model.config || {}
			let valueChanged = false

			if(value !== undefined){
				valueChanged = this.model.data !== value
				this.model.data = value
			} else {
				valueChanged = this.model.data !== this.model[this.model.dataFlag]
				this.model.data = this.model[this.model.dataFlag]

				// set defaultValue if necessary
				if(!this.model.data && fieldConfig.defaultValue !== undefined && this.model.data !== fieldConfig.defaultValue){
					valueChanged = true
					this.model.data = fieldConfig.defaultValue
				}
			}

			if(this.model.dataINT !== undefined || (this.model.atom || {}).dataType === 'integer'){
				if(!this.model.data && this.model.data !== 0){
					this.model.data = null
					this.model.dataFormatted = ''
				} else {
					this.format();
				}
			}
			else if(this.model.dataFLOAT !== undefined || (this.model.atom || {}).dataType === 'float'){
				if(!this.model.data && this.model.data !== 0){
					this.model.data = null
					this.model.dataFormatted = ''
				} else {
					this.format();
				}
			}
			else {
				this.model.dataFormatted = this.model.data;
			}

			if(valueChanged){
				this.updateKeyDownLabelValue();

				if(this.$){
					this.$.find('input').val(this.model.dataFormatted);
				}
				if(tellParents && this.model.data !== undefined){
					this.triggerClosest('onChildChanged', {
						fieldCode: this.model.fieldCode,
						fieldKey: this.model.fieldKey,
						value: this.model.data
					});
				}
			}
		},

		format: function(){
			var fieldConfig = this.model.config || {};
			var data = utils.number.format(this.model.data || 0, {
				changeValueGranted: true,
				...(fieldConfig.currencyFormat || fieldConfig.format || {}),
			}, (this.model.atom || {}).dataType || 'integer');

			if(isNaN(data.value)){
				delete data.value
				delete data.formatted
			}

			this.model.data = data.value;
			this.model.dataFormatted = data.formatted;
		},

		updateKeyDownLabelValue: function(forceValue){
			var self = this;
			if(self.model.config.keyDownLabel || self.model.config.keyDownLabelTriggerOnly){
				var value = self.model.dataFormatted;
				if(forceValue !== undefined){
					value = forceValue;
				}
				self.parentComponents(undefined, function(parentComponent){
					if(utils.isFunction(parentComponent.updateKeyDownLabelValue)){
						self.model.keyDownLabel = parentComponent.updateKeyDownLabelValue(self.model.fieldCode, self.model.config, value, self);
						return false
					}
				});

				if(self.model.config.keyDownLabel && self.$){
					self.$.find('label').html(self.model.keyDownLabel).attr('title', self.model.keyDownLabel);
				}
			}
		},

		enable: function(){
			if(this.model.disabled){
				this.model.disabled = false;
				this.refresh(false);
			}
		},

		disable: function(){
			if(!this.model.disabled){
				this.model.disabled = true;
				this.refresh(false);
			}
		}
	},

	hooks: {
		updateKeyDownLabelValue: function($element, options){
			var self = this;
			if(self.model.config.keyDownLabel && self.$ && options.value){
				self.model.keyDownLabel = options.value;
				self.$.find('label').html(self.model.keyDownLabel).attr('title', self.model.keyDownLabel);
			}
		}
	}
};
